'use client'
import { ArrowForward, Star } from '@mui/icons-material';
import { PlanUpgradeBackground } from '@practium/ui';
import styles from './ProfilePlanUpgradeCard.module.css';

interface ProfilePlanUpgradeCardProps {
	planName: string;
	description: string;
	validUntil: string;
	canUpgrade: boolean;
	upgradePlanName?: string;
	onUpgrade?: () => void;
}

export const ProfilePlanUpgradeCard = ({
	planName,
	description,
	validUntil,
	canUpgrade,
	upgradePlanName,
	onUpgrade,
}: ProfilePlanUpgradeCardProps) => {
	return (
		<div className={styles.planCard}>
			<PlanUpgradeBackground className={styles.svg} />

			<div className={styles.cardContent}>
				<div className={styles.statusBadge}>
					<p className={styles.statusText}>{canUpgrade ? 'Status do Plano' : 'Assinatura Ativa'}</p>
				</div>
				<div className={styles.contentWrapper}>
					<div className={styles.infoSection}>
						<h2 className={styles.planTitle}>
							{planName}
							<Star className={styles.starIcon} />
						</h2>
						<p className={styles.planDescription}>{description}</p>
					</div>

					<div className={styles.actionSection}>
						{canUpgrade && upgradePlanName ? (
							<button className={styles.upgradeButton} onClick={onUpgrade}>
								Upgrade para {upgradePlanName}
								<ArrowForward className={styles.arrowIcon} />
							</button>
						) : (
							<div className={styles.maxPlanBadge}>
								<span>Assinatura Corporativa</span>
							</div>
						)}
						<p className={styles.validityText}>
							{validUntil === '∞' ? 'Acesso Vitalício' : `Assinatura válida até ${validUntil}`}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
